import { apiClient } from '@/libs/axios';
import {
  toUploadTransferProofDTO,
  type UploadTransferProofDTO,
} from '../schemas/upload-transfer-proof.schema';

export const uploadTransferProof = async (
  id: number,
  data: FormData
): Promise<UploadTransferProofDTO> => {
  const response = await apiClient.patch(
    `withdraw/${id}/transfer-proof`,
    data,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );

  return toUploadTransferProofDTO(response);
};
